// externals
import type { FC } from 'react';

// components
import { StyledFooterContainer, StyledFooterRow } from './Footer.style';
import { OpenDeal } from './openDeal/OpenDeal';
import { CancelDeal } from './cancelDeal/CancelDeal';

export interface FooterProps {
    isVehicleEditMode?: boolean;
}

export const Footer: FC<FooterProps> = ({ isVehicleEditMode = false }) => {
    // Hide buttons when vehicle is in edit mode
    if (isVehicleEditMode) {
        return null;
    }

    return (
        <StyledFooterContainer>
            <StyledFooterRow>
                <CancelDeal />
                <OpenDeal />
            </StyledFooterRow>
        </StyledFooterContainer>
    );
};
